<template>
  <v-layout class="workers-statistics" wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline mb-2">
            {{ $t('workersStatistics.title') }}
          </h1>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex class="d-flex mb-2" x12>
      <!-- <div class="workers-statistics__filter">
        <menu-datepicker
          :value="filters.date"
          @change="filters.date = $event"
        />
      </div> -->
      <v-menu
        ref="menuDate"
        :close-on-content-click="false"
        v-model="menuDate"
        :return-value.sync="filters.dates"
        max-width="280px"
        min-width="280px"
        class="pr-4 mt-2"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-on="on"
            v-model="filters.dates"
            prepend-icon="mdi-calendar"
            :label="$t('common.fields.rentDate')"
            readonly
            class="workers-statistics__filter"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="filters.dates"
          color="primary lighten-1"
          width="280"
          range
          :locale="$i18n.locale"
          :selected-items-text="filters.dates.toString()"
          :allowed-dates="allowedDates"
          @input="changeDate"
        ></v-date-picker>
      </v-menu>
      <v-select
        v-model="filters.carParks"
        class="workers-statistics__filter"
        item-text="name"
        item-value="id"
        :label="$t('employees.park')"
        :items="parks"
        multiple
        clearable
      >
        <template #selection="{ index }">
          <template v-if="index > 0"></template>
          <template v-else>
            {{ filters.carParks.length }}
            {{ $t('common.selected') }}
          </template>
        </template>
      </v-select>
    </v-flex>

    <v-flex xs12>
      <v-data-table
        ref="statistics-table"
        class="workers-statistics__table"
        hide-default-header
        hide-default-footer
        :headers="headers"
        :items="list"
        :items-per-page="-1"
        :height="tableHeight"
        :loading="loading"
      >
        <template #header>
          <thead class="v-data-table-header">
            <tr>
              <template v-for="(header, key) in headers">
                <th
                  class="text-align-center"
                  :class="{ section: header.sections }"
                  :style="{
                    minWidth: header.width || 'auto',
                    maxWidth: header.width || 'none',
                  }"
                  :key="key"
                  :colspan="header.sections ? header.sections.length : 1"
                >
                  {{ header.sections ? $t(header.text) : '' }}
                </th>
              </template>
            </tr>

            <tr>
              <template v-for="(header, key) in headers">
                <template>
                  <th v-if="!header.sections" :key="key">
                    {{ $t(header.text) }}
                  </th>

                  <th
                    v-else
                    v-for="(item, idx) in header.sections"
                    :key="header.text + idx"
                    class="section"
                  >
                    {{ $t(item.text) }}
                  </th>
                </template>
              </template>
            </tr>
          </thead>
        </template>

        <template #item="{ item, index }">
          <tr>
            <td>{{ item.num }}</td>
            <td class="nowrap">{{ item.date }}</td>
            <td>{{ item.car_count || 0 }}</td>
            <td>{{ item.cars_on_line || 0 }}</td>
            <td>{{ item.cars_vacation || 0 }}</td>
            <td>{{ item.daytime_shift || 0 }}</td>
            <td>{{ item.night_shift || 0 }}</td>
            <td>{{ item.day_shift || 0 }}</td>
            <td>{{ item.autos_left || 0 }}</td>
            <td v-html="getNumbersList(item.autos_left_numbers)" />
            <td>{{ item.autos_arrived || 0 }}</td>
            <td v-html="getNumbersList(item.autos_arrived_numbers)" />
            <td>{{ item.cars_on_parking || 0 }}</td>
            <td v-html="getNumbersList(item.cars_on_parking_numbers)" />
            <td>{{ item.cars_on_parking_fine || 0 }}</td>
            <td v-html="getNumbersList(item.cars_on_parking_fine_numbers)" />
            <td>{{ item.cars_no_kasko || 0 }}</td>
            <td v-html="getNumbersList(item.cars_no_kasko_numbers)" />
            <td>{{ item.cars_on_sto || 0 }}</td>
            <td v-html="getNumbersList(item.cars_on_sto_numbers)" />
            <td>{{ item.cars_investor || 0 }}</td>
            <td v-html="getNumbersList(item.cars_investor_numbers)" />
            <td>{{ item.cars_on_repair || 0 }}</td>
            <td v-html="getNumbersList(item.cars_on_repair_numbers)" />
            <td>{{ item.cars_accident || 0 }}</td>
            <td v-html="getNumbersList(item.cars_accident_numbers)" />
            <td>{{ item.cars_in_buyout || 0 }}</td>
            <td v-html="getNumbersList(item.cars_in_buyout_numbers)" />
            <td>{{ item.new_cars || 0 }}</td>
            <td v-html="getNumbersList(item.new_cars_numbers)" />
            <td>{{ item.inactive_cars || 0 }}</td>
            <td v-html="getNumbersList(item.inactive_cars_numbers)" />
            <td>{{ item.new_active_cars || 0 }}</td>
            <td v-html="getNumbersList(item.new_active_cars_numbers)" />
          </tr>

          <tr
            v-if="index === list.length - 1"
            class="workers-statistics__table-totals grey lighten-3"
          >
            <td>
              <b>{{ $t('common.total') }}</b>
            </td>
            <td />
            <td />
            <td>{{ totals.cars_on_line }}</td>
            <td>{{ totals.cars_vacation }}</td>
            <td>{{ totals.daytime_shift }}</td>
            <td>{{ totals.night_shift }}</td>
            <td>{{ totals.day_shift }}</td>
            <td>{{ totals.autos_left }}</td>
            <td />
            <td>{{ totals.autos_arrived }}</td>
            <td />
            <td>{{ totals.cars_on_parking }}</td>
            <td />
            <td>{{ totals.cars_on_parking_fine }}</td>
            <td />
            <td>{{ totals.cars_no_kasko }}</td>
            <td />
            <td>{{ totals.cars_on_sto }}</td>
            <td />
            <td>{{ totals.cars_investor }}</td>
            <td />
            <td>{{ totals.cars_on_repair }}</td>
            <td />
            <td>{{ totals.cars_accident }}</td>
            <td />
            <td>{{ totals.cars_in_buyout }}</td>
            <td />
            <td>{{ totals.new_cars }}</td>
            <td />
            <td>{{ totals.inactive_cars }}</td>
            <td />
            <td>{{ totals.new_active_cars }}</td>
            <td />
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';
import hasPermission from '@/helpers/hasPermission';
import store from '@/store';
import calcTableHeight from '@/helpers/calcTableHeight';

export default {
  data() {
    return {
      loading: false,
      parksLoading: false,
      menuDate: false,
      tableHeight: 'auto',
      filters: {
        dates: [],
        parks: [],
      },

      headers: [
        { text: 'common.number', width: '48px' },
        { text: 'common.fields.bookingDate', width: '98px' },
        { text: 'workersStatistics.allAutosTotal', width: '179px' },
        {
          text: 'workersStatistics.online',
          sections: [{ text: 'workersStatistics.autosTotal' }],
        },
        {
          text: 'workersStatistics.dayOff',
          sections: [{ text: 'workersStatistics.autosTotal' }],
        },
        {
          text: 'common.day',
          sections: [{ text: 'workersStatistics.autosTotal' }],
        },
        {
          text: 'common.night',
          sections: [{ text: 'workersStatistics.autosTotal' }],
        },
        {
          text: 'common.twenty-four-hours',
          sections: [{ text: 'workersStatistics.autosTotal' }],
        },
        {
          text: 'workersStatistics.left',
          sections: [
            { text: 'workersStatistics.autosTotal' },
            { text: 'workersStatistics.autosNumber' },
          ],
        },
        {
          text: 'workersStatistics.passed',
          sections: [
            { text: 'workersStatistics.autosTotal' },
            { text: 'workersStatistics.autosNumber' },
          ],
        },
        {
          text: 'workersStatistics.parkingLot',
          sections: [
            { text: 'workersStatistics.autosTotal' },
            { text: 'workersStatistics.autosNumber' },
          ],
        },
        {
          text: 'workersStatistics.fineParkingLot',
          sections: [
            { text: 'workersStatistics.autosTotal' },
            { text: 'workersStatistics.autosNumber' },
          ],
        },
        {
          text: 'workersStatistics.noInsurance',
          sections: [
            { text: 'workersStatistics.autosTotal' },
            { text: 'workersStatistics.autosNumber' },
          ],
        },
        {
          text: 'workersStatistics.onService',
          sections: [
            { text: 'workersStatistics.autosTotal' },
            { text: 'workersStatistics.autosNumber' },
          ],
        },
        {
          text: 'workersStatistics.investor',
          sections: [
            { text: 'workersStatistics.autosTotal' },
            { text: 'workersStatistics.autosNumber' },
          ],
        },
        {
          text: 'workersStatistics.chiropractor',
          sections: [
            { text: 'workersStatistics.autosTotal' },
            { text: 'workersStatistics.autosNumber' },
          ],
        },
        {
          text: 'workersStatistics.dtp',
          sections: [
            { text: 'workersStatistics.autosTotal' },
            { text: 'workersStatistics.autosNumber' },
          ],
        },
        {
          text: 'workersStatistics.buyout',
          sections: [
            { text: 'workersStatistics.autosTotal' },
            { text: 'workersStatistics.autosNumber' },
          ],
        },
        {
          text: 'workersStatistics.newAutos',
          sections: [
            { text: 'workersStatistics.autosTotal' },
            { text: 'workersStatistics.autosNumber' },
          ],
        },
        {
          text: 'workersStatistics.goneInactive',
          sections: [
            { text: 'workersStatistics.autosTotal' },
            { text: 'workersStatistics.autosNumber' },
          ],
        },
        {
          text: 'workersStatistics.cameToActive',
          sections: [
            { text: 'workersStatistics.autosTotal' },
            { text: 'workersStatistics.autosNumber' },
          ],
        },
      ],
    };
  },
  watch: {
    filters: {
      deep: true,
      handler(params) {
        if (params.dates.length === 1) return;
        this.fetchList(params);
      },
    },
  },
  computed: {
    ...mapState({
      list: (state) => state['workers-board'].statistics,
      parks: ({ parks }) => parks.list,
    }),
    today() {
      const date = new Date();
      const formatNum = (v) => (v < 10 ? `0${v}` : v);

      return `${date.getFullYear()}-${formatNum(
        date.getMonth() + 1,
      )}-${formatNum(date.getDate())}`;
    },
    totals() {
      /* eslint-disable */
      return this.list.reduce((obj, item) => {
        Object.entries(item).forEach(([key, value]) => {
          const isExist = key in obj;
          const isNumber = typeof value === 'number';

          if (!isExist) obj[key] = 0;
          if (!isNumber) return;

          obj[key] += value;
        });

        return obj;
      }, {});
      /* eslint-enable */
    },
  },
  methods: {
    async fetchParks() {
      this.parksLoading = true;
      await this.$store.dispatch('parks/fetchList');
      this.parksLoading = false;
    },
    async fetchList(params) {
      this.loading = true;
      await this.$store.dispatch('workers-board/fetchStatistics', params);
      this.loading = false;
    },
    changeDate(val) {
      if (val.length === 2) {
        this.$refs.menuDate.save(this.filters.dates);
      }
    },
    allowedDates(value) {
      const [from, to] = this.filters.dates;

      if (!from) return true;
      if (to) return true;

      const firstDate = new Date(from);
      const nextDate = new Date(value);

      return nextDate >= firstDate;
    },
    getNumbersList(numbers) {
      if (!numbers) return '—';

      const numbersList = numbers.split(',');

      const listItems = numbersList.reduce((template, number) => {
        template += `<li>${number}</li>`; // eslint-disable-line
        return template;
      }, '');

      return `<ul class="workers-statistics__numbers">${listItems}</ul>`;
    },
  },
  async beforeRouteEnter(to, from, next) {
    await store.commit('global/setRole', null, { root: true });

    if (!hasPermission('workdesk_view_statistic')) {
      next('/workers-board');
    }

    if (store.getters['global/getRole'] !== 'investor') {
      next();
    } else {
      next('/investor-board');
    }
  },
  created() {
    this.fetchParks();
    this.filters.dates = [this.today, this.today];
  },
  mounted() {
    const table = this.$refs['statistics-table'];
    this.tableHeight = calcTableHeight(table.$el);
  },
};
</script>

<style lang="scss">
.workers-statistics {
  &__filter {
    max-width: 250px;
    width: 100%;
    margin-right: 30px;
  }

  &__numbers {
    display: block;
    max-height: 50px;
    padding: 5px 0 5px !important;
    overflow-y: auto;
    scrollbar-color: #c9c9c9, transparent;
    scrollbar-width: thin;
    &::-webkit-scrollbar {
      width: 10px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.15);
      background-clip: padding-box;
      border-radius: 20px;
      border: solid 2px rgba(0, 0, 0, 0);
    }
    &::-webkit-scrollbar-button {
      width: 0;
      height: 0;
      display: none;
    }
    &::-webkit-scrollbar-corner {
      background-color: transparent;
    }

    li {
      list-style: none;
      font-size: 12px;
    }
  }

  &__table {
    &-totals {
      position: sticky;
      bottom: 0;
      font-weight: 700;
    }

    .v-data-table-header {
      position: sticky;
      top: 0;
      z-index: 1;

      tr:first-child th {
        height: 30px !important;
        font-weight: 600 !important;
        text-align: center !important;

        &.section {
          border-bottom: 1px dashed rgba(255, 255, 255, 0.5);
        }
      }

      th {
        white-space: nowrap;
        height: 35px !important;

        &.section {
          background-color: lighten(#424242, 10%) !important;
        }
      }

      tr {
        transition: 0.3s !important;
      }
    }

    tr td {
      &:first-child,
      &:nth-child(2),
      &:nth-child(3) {
        background-color: #f8f8f8;
        border-color: #e8e8e8 !important;
      }
    }

    tr > th:first-child,
    tr > td:first-child {
      position: sticky;
      left: 0;
    }

    tr > th:nth-child(2),
    tr > td:nth-child(2) {
      position: sticky;
      left: 48px;
    }

    tr > th:nth-child(3),
    tr > td:nth-child(3) {
      position: sticky;
      left: 146px;
      border-right: 2px solid #dddddd;
    }

    .v-pagination button {
      box-shadow: none !important;
    }
  }

  .nowrap {
    white-space: nowrap;
  }
}
</style>
